import { IWobGliderBaseConstParam, WobGliderBase } from '@/models/wob//WobGliderBase'
import { AloDataRawSet, IAloDataRawSetConstParam } from '../alo/AloDataRawSet'

export interface IwobGliderNmeaConstParam extends IWobGliderBaseConstParam {  
  nmeaData: IAloDataRawSetConstParam
}

export class wobGliderNmea extends WobGliderBase {  
  public nmeaData: AloDataRawSet

  constructor({ nmeaData, ...args }: IwobGliderNmeaConstParam) {
    super(args)
    this.nmeaData = AloDataRawSet.createAloDataRawSetWithDetail(nmeaData)
  }
}
